// extracted by mini-css-extract-plugin
module.exports = {"root":"offline-activity-animation_root__1oYEV","layer":"offline-activity-animation_layer__1N2c2","animWrap":"offline-activity-animation_animWrap__EhrCO"};